// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-scroll';
import { ButtonGroup } from 'react-bootstrap';
import { css } from 'glamor';

const containerRule = css({
    textAlign: 'center',
});

const linkRule = css({
    height: '50px',
    fontSize: '0.9em',
    backgroundColor: '#e0e0e0',
    color: '#484848',
    textTransform: 'uppercase',
    fontWeight: 600,
    borderRadius: 0,

    transition: 'all 0.5s ease',

    '&:hover': {
        backgroundColor: 'rgb(228, 65, 34)',
        color: '#fff',
    },

    '&.active': {
        backgroundColor: 'rgb(228, 65, 34)',
        color: '#fff',
    },

    '@media(max-width: 768px)': {
        fontSize: '0.7em',
        padding: 0,
    },
});

@observer
export default class SectionScroller extends React.Component {
    props: {
        sections: Array<any>,
    };

    render() {
        const { sections } = this.props;

        return (
            <div { ...containerRule }>
                <ButtonGroup justified role="group">
                    {sections.map(s => (
                        <Link
                            { ...linkRule }
                            className="btn"
                            to={ s.name }
                            spy
                            smooth
                            duration={ 500 }
                            offset={ s.label === 'game' ? 0 : -50 }
                            key={ s.name }
                        >
                            {s.label}
                        </Link>
                    ))}
                </ButtonGroup>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/SectionScroller/index.js